export const getNumericDocumentBySlug = () => {
  return `query getNumericDocumentBySlug($slug: String!) {
    numericDocumentBySlug(slug: $slug) {
      ...on NumericDocument{
        id
        slug
        title
        titleEn: titleEn
        textFr: textFr_html
        textEn: textEn_html
        source
        publishingStartDate
        authors{firstName, lastName, slug}
        copyrights{nameC}
      }

    }
  }`
}
